<template>
<div>
    <v-card flat color="transparent" class="mt-7">
        <v-toolbar  class="bdr secondary2light" :elevation="0" outlined>
            <v-toolbar-title>{{$t('animal.conception')}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip top color="black">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        icon
                        small
                        :to="{ name: 'AnimalConceptionEdit', params: {animal_number: $route.params.animal_number}}"
                        class="mr-2"
                    >
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </template>
                <span>{{$t('animal.conceptionInfo.addNewConception')}}</span>
            </v-tooltip>
            
            <!-- <v-btn
                icon
                large
                disabled
            >
                <v-icon>mdi-cog-outline</v-icon>
            </v-btn> -->
        </v-toolbar>
    </v-card>
    <v-card flat class="mt-7">
        <v-card-text>
            <div class="tabs-section">
                <template>
                    <v-tabs class="tabs-pill" v-model="tab">
                        <v-tab>{{$t('animal.conception')}} </v-tab>
                        <v-tab>{{$t('animal.conceptionInfo.semenEmbryo')}} </v-tab>
                        <v-tab>{{$t('animal.conceptionInfo.pregnancyCheck')}}</v-tab>
                        <v-tab>{{$t('animal.conceptionInfo.birthInfo')}}</v-tab>
                    </v-tabs>
                </template>
            </div>
            <v-tabs-items v-model="tab">
                <v-tab-item> <conception/> </v-tab-item>
                <v-tab-item> <semen-embryo/> </v-tab-item>
                <v-tab-item> <pregnancy-check/> </v-tab-item>
                <v-tab-item> <birth-info/> </v-tab-item>
            </v-tabs-items>
        </v-card-text>
    </v-card>
</div>
</template>
<script>

import BirthInfo from "./conception/BirthInfo.vue"
import SemenEmbryo from "./conception/SemenEmbryo.vue"
import PregnancyCheck from "./conception/PregnancyCheck.vue"
import Conception from './conception/Conception.vue'
export default {
    components: {
        BirthInfo,
        SemenEmbryo,
        PregnancyCheck,
        Conception,
    },
    created() {
        // if(this.$route.params.type){
        //     let index = this.tabs.indexOf(this.$route.params.type);
        //     if(index != -1)
        //         this.tab = index
        // }
        const fetchData = async () => {
        }
        fetchData();
        
    },
    data : () => ({
        tab: 0,
        tabs: ['cp', 'se', 'pc', 'bi']
    }),

    methods: { }
}
</script>
<style lang="scss" scoped>
.bdr {
    border: thin solid $secondary-color;
}

::v-deep .v-tab:hover {
  background-color: #caf1e2;
  color: $primary_color !important;
}
</style>